import Skeleton from "react-loading-skeleton";
import { useClient, useToken } from "../../../lib/context/auth-context";
import { useCurrencies } from "../../../lib/util";

export const formatCurrency = (
  amount,
  currencyCode,
  currencies = [],
  isLoadingCurrencies = false,
) => {
  if (isLoadingCurrencies) {
    return <Skeleton height={22} width={80} style={{ borderRadius: 2 }} />;
  }
  if (!currencyCode) {
    return Number(amount).toLocaleString();
  }
  const matched = currencies.find((c) => c.currency === currencyCode);
  if (matched?.symbol) {
    return `${matched.symbol} ${Number(amount).toLocaleString()}`;
  }

  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currencyCode,
  }).format(amount);
};

export const useFormatCurrency = () => {
  const client = useClient();
  const { token } = useToken();
  const { data: currencies = [], isLoading: isLoadingCurrencies } =
    useCurrencies(client, token);

  const formatWithCurrencies = (amount, currencyCode) =>
    formatCurrency(amount, currencyCode, currencies, false);

  return {
    formatCurrency: formatWithCurrencies,
    currencies,
    isLoadingCurrencies,
  };
};
